export default "__VITE_ASSET__2e28121f__"